import { useEffect } from 'react'

interface UseOtpAutoSubmitParams {
  value: string
  length?: number
  enabled?: boolean
  isProcessing?: boolean
  onSubmit: (value: string) => void
}

export const useOtpAutoSubmit = ({
  value,
  length = 6,
  enabled = true,
  isProcessing = false,
  onSubmit
}: UseOtpAutoSubmitParams) => {
  useEffect(() => {
    if (!enabled || isProcessing) return

    if (value.length === length) {
      onSubmit(value)
    }
  }, [value, length, enabled, isProcessing, onSubmit])
}
